
export const convertDateFormat = (inputDate) => {
    let date = new Date(inputDate);
    if (!Number.isNaN(date.getTime())) {
        let resultDay = ((date.getDate()).toString()).length == 1 ? ('0'+(date.getDate())) : date.getDate()
        let resultMonth = ((date.getMonth() + 1).toString()).length == 1 ? ('0'+(date.getMonth() + 1)) : date.getMonth() + 1
        let resultDate =  (resultDay + '/' + (resultMonth) + '/' + date.getFullYear());
        return resultDate;
    }
  }